<div class="w-full" [class.compact-field]="compact()" [class.has-error]="state.hasError" [ngClass]="'size-' + size()">
  <div class="multi-line-label" [class.mb-1]="compact()" dojoFormFieldLabel *ngIf="label()">
    @if (labelTemplate()) {
      <ng-container *ngTemplateOutlet="labelTemplate()"></ng-container>
    } @else {
      <span>{{ label() }}</span>
    }
  </div>

  <div class="multi-line-field-wrap" [ngClass]="'size-' + size()" [class.border-red-600]="state.hasError">
    <div
      class="multi-line-field"
      #multiLineTextDiv
      [contentEditable]="!formCtrl().disabled"
      [attr.data-placeholder]="placeholder() || ''"
      [class.cursor-not-allowed]="formCtrl().disabled"
      [class.bg-gray-100]="formCtrl().disabled"
      [class.text-disabled]="formCtrl().disabled"
      [style.min-height]="minHeight()"
      [style.max-height]="maxHeight()"
    ></div>
  </div>

  @if (!hideErrors() && state.errorMessage) {
    <div class="multi-line-field-error text-sm text-red-700">
      {{ state.errorMessage }}
    </div>
  }
</div>
